/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from "react";
import Button from "../elements/Button";

export default function BrandIcon() {
  return (
    <Button className="flex items-center space-x-4" type="link" href="/">
      <img
        src="../assets/images/header.png"
        alt="HeaderImg"
        className="w-auto h-16 invert"
      />{" "}
      {/* Adjusted size */}
    </Button>
  );
}
